export const getEditingRoomData = (editingRoom) => {
  const { tenants, ...restData } = editingRoom;
  return restData;
};
